import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ProjectSummaryDataService } from '../../data-access/project-summary-data.service';
import { ProjectSummaryAction, ProjectSummaryRow, ProjectSummarySort } from '../../data-access/project-summary.types';

@Component({
    selector: 'app-project-summary-table-container',
    templateUrl: './project-summary-table-container.component.html'
})
export class ProjectSummaryTableContainerComponent implements OnChanges {
    @Input() projects: unknown[] = [];
    @Input() selectedProjectIds: number[] = [];
    @Input() indicateNewProjects = true;
    @Input() newSince?: string;
    @Input() updatedSince?: string;
    @Input() usage = 'default';
    @Input() sort?: ProjectSummarySort;
    @Input() actions: ProjectSummaryAction[] = [];

    @Output() projectSelected = new EventEmitter<ProjectSummaryRow>();
    @Output() selectionChanged = new EventEmitter<number[]>();
    @Output() restoreRequested = new EventEmitter<number>();
    @Output() sortChanged = new EventEmitter<ProjectSummarySort>();

    rows: ProjectSummaryRow[] = [];

    constructor(private projectSummaryData: ProjectSummaryDataService) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.projects) {
            this.rows = this.projectSummaryData.toRows(this.projects || []);
        }
    }

    onProjectSelected(row: ProjectSummaryRow): void {
        this.projectSelected.emit(row);
    }

    onSelectionChanged(projectIds: number[]): void {
        this.selectionChanged.emit(projectIds);
    }

    onRestoreRequested(projectID: number): void {
        this.restoreRequested.emit(projectID);
    }

    onSortChanged(sort: ProjectSummarySort): void {
        this.sortChanged.emit(sort);
    }
}
